import MeetConnectionTestIframe from '@/components/meet-connection-test';

const MeetConnectionTest = () => {
	return <MeetConnectionTestIframe />;
};

export default MeetConnectionTest;
